import { FormAction } from '@anytag/shared-types';
import { objectKeys } from '@anytag/shared-assets';
import { useQueryHelper } from '@anytag/shared-hooks';
import { CmsChannelShareRateInput, namedOperations, useUpdateCmsChannelShareRateMutation } from '@anytag/graphql';
import { YoutubeCMSChannelRevenueFormValues } from '../YoutubeCMSChannelsList';
import { useYoutubeCMSFilter } from './useYoutubeCMSFilter';

export const useUpdateYoutubeChannelShareRate = () => {
  const { filter } = useYoutubeCMSFilter();
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callUpdateCmsChannelShareRate } = useUpdateCmsChannelShareRateMutation({
    refetchQueries: [namedOperations.Query.AllYoutubeCmsEstimateChannels, namedOperations.Query.YoutubeCmsChannelDetail]
  });

  const handleSaveChange: FormAction<YoutubeCMSChannelRevenueFormValues>['onSubmit'] = async (
    values,
    { formState, reset }
  ) => {
    try {
      await callUpdateCmsChannelShareRate({
        variables: {
          input: {
            month: filter.month,
            channels: objectKeys(formState.dirtyFields).reduce<CmsChannelShareRateInput[]>(
              (acc, curr) => [
                ...acc,
                { channelId: curr.split('-').at(0)!, shareRate: Number(values[curr] || 0) / 100 }
              ],
              []
            )
          }
        }
      });

      enqueueSnackbar(t('Share rate has been updated'), { variant: 'success' });
      reset(values);
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  };

  return { handleSaveChange };
};
